import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Row } from "./RowsTableRoles";
import { Box, TablePagination } from "@mui/material";
import ModalDetailsRole from "../ModalDetailsRole";

export default function TableRoles({ rows = [], setLoading, type }) {
  const [page, setPage] = React.useState(0);
  const [selectedRole, setSelectedRole] = React.useState(null);
  const [showModalDetailsRole, setShowModalDetailsRole] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);
  return (
    <>
      <ModalDetailsRole
        open={showModalDetailsRole}
        setOpen={setShowModalDetailsRole}
        roleData={selectedRole}
      />
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>ID</TableCell>
                  <TableCell align="center">Rol</TableCell>
                  <TableCell align="center">Descripción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => {
                  return (
                    <Row
                      key={row._id}
                      row={row}
                      setShowModalDetailsRole={setShowModalDetailsRole}
                      setSelectedRole={setSelectedRole}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
